import React from 'react';
import { useThemeContext } from 'src/context/ThemeProvider';

const useGetLogo = () => {
	const { themeMode } = useThemeContext();

	const placedByMasai =
		themeMode === 'dark'
			? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
			: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/levelupbymasai_l_1cb51fe754.svg';
	const levelUpLogo =
		themeMode === 'dark'
			? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
			: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png';

	const domain = window.location.hostname;
	const logo = domain === 'levelup.inc' ? levelUpLogo : placedByMasai;

	return { logo };
};

export default useGetLogo;
